/** Shared meal-edit policy used by the customer, staff and write-validation surfaces. */
export const CANNOT_REMOVE_SELECTION_MESSAGE = "JotForm's API can't remove selections — remove it on the JotForm form itself for now.";
export const CANNOT_REMOVE_SELECTION_CUSTOMER_MESSAGE = 'Options can be added but not removed online — to remove one, call The Fairy Tails.';
export const CANNOT_CLEAR_FOOD_DETAILS_CUSTOMER_MESSAGE = 'Food details cannot be cleared online — to remove one, call The Fairy Tails.';
/** The meal-form fields an owner may change without altering the identity matching signal. */
export const CUSTOMER_EDITABLE_MEAL_QIDS = [
    '26',
    '38',
    '40',
    '43',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '55',
    '56',
    '61',
];
//# sourceMappingURL=meal-edit.js.map